import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Heading from './Heading';
import CategoryBlock from './CategoryBlock';
import withTrackingPropsProvider from '../../../hocs/withTrackingPropsProvider';
import Button from '../../Common/Button';
import { PaddedLandingPageComponent } from '../../../styling/layout-containers/LandingPageContainers';
import {
  DESKTOP_START_QUERY,
  DESKTOP_MEDIUM_START_QUERY,
} from '../../../styling/mixins/responsive';

const Container = styled(PaddedLandingPageComponent)`
  margin: 1rem 0;
  padding: 0 1rem;

  @media (${DESKTOP_MEDIUM_START_QUERY}) {
    margin: 1.5rem 0;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin: 0 -0.5rem;

  @media (${DESKTOP_START_QUERY}) {
    flex-flow: row;
  }

  @media (${DESKTOP_MEDIUM_START_QUERY}) {
    margin: 0 -1rem;
  }
`;

const Centered = styled.div`
  margin-top: 1rem;
  margin-bottom: 4rem;
  text-align: center;
`;

function renderBlock({ key, singleCardMobile, category }) {
  return (
    <CategoryBlock
      key={key}
      singleCardMobile={singleCardMobile}
      {...category}
    />
  );
}

class CategoryBlocks extends Component {
  static propTypes = {
    button: PropTypes.shape({
      children: PropTypes.string,
      color: PropTypes.string,
      href: PropTypes.string,
      type: PropTypes.string,
    }),
    className: PropTypes.string,
    title: PropTypes.string,
    link: PropTypes.object,
    renderBlock: PropTypes.func,
    categories: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        url: PropTypes.string,
        cards: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string,
            shape: PropTypes.string,
            image: PropTypes.string,
          }),
        ),
        color: PropTypes.string,
      }),
    ),
  };

  static defaultProps = {
    renderBlock,
  };

  render() {
    const {
      button,
      categories,
      className,
      title,
      link,
      renderBlock,
    } = this.props;

    return (
      <Container className={className}>
        {title && <Heading title={title} link={link} />}
        <Wrapper>
          {categories.map((category, i) =>
            renderBlock({
              key: i,
              singleCardMobile: categories.length !== 3 || i > 0,
              category,
            }),
          )}
        </Wrapper>
        {button && (
          <Centered>
            <Button {...button} />
          </Centered>
        )}
      </Container>
    );
  }
}

export default withTrackingPropsProvider(CategoryBlocks);
